module.exports = __webpack_public_path__ + "static/media/logo-modal.d8b82c88.svg";